"use strict";

var _defineProperty = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactTransitionGroup = require("react-transition-group");

var _router = require("@reach/router");

var _TransitionRenderer = _interopRequireDefault(require("./TransitionRenderer"));

var _delayTransitionRender = _interopRequireDefault(require("./delayTransitionRender"));

var _createTransitionContext = require("../context/createTransitionContext");

var _onEnter = require("../functions/onEnter");

var _onExit = require("../functions/onExit");

var _secondsMs = require("../utils/secondsMs");

require("../style.css");

var _jsxFileName = "/Users/tyler/Documents/GitHub/gatsby-plugins/transition-link/gatsby-plugin-transition-link/src/components/TransitionHandler.js";
var DelayedTransition = (0, _delayTransitionRender.default)(_reactTransitionGroup.Transition);

var TransitionHandler = /*#__PURE__*/function (_react$Component) {
  _inherits(TransitionHandler, _react$Component);

  var _super = _createSuper(TransitionHandler);

  function TransitionHandler() {
    _classCallCheck(this, TransitionHandler);

    return _super.apply(this, arguments);
  }

  _createClass(TransitionHandler, [{
    key: "render",
    value: function render() {
      var _this = this;

      var props = this.props;
      var children = props.children,
          _props$injectPageProp = props.injectPageProps,
          injectPageProps = _props$injectPageProp === void 0 ? true : _props$injectPageProp;
      return /*#__PURE__*/_react.default.createElement(_createTransitionContext.Consumer, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 21,
          columnNumber: 4
        }
      }, function (_ref) {
        var exitDelay = _ref.exitDelay,
            exitLength = _ref.exitLength,
            exitState = _ref.exitState,
            entryDelay = _ref.entryDelay,
            entryLength = _ref.entryLength,
            entryState = _ref.entryState,
            entryTrigger = _ref.entryTrigger,
            entryProps = _ref.entryProps,
            exitTrigger = _ref.exitTrigger,
            exitProps = _ref.exitProps,
            inTransition = _ref.inTransition,
            updateContext = _ref.updateContext,
            triggerResolve = _ref.triggerResolve,
            appearAfter = _ref.appearAfter,
            preventScrollJump = _ref.preventScrollJump,
            hash = _ref.hash,
            e = _ref.e;
        return /*#__PURE__*/_react.default.createElement(_router.Location, {
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 42,
            columnNumber: 7
          }
        }, function (_ref2) {
          var location = _ref2.location;
          var action = location.action,
              pathname = location.pathname,
              locationKey = location.key;
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "tl-edges",
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 51,
              columnNumber: 10
            }
          }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, {
            component: null,
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 52,
              columnNumber: 11
            }
          }, /*#__PURE__*/_react.default.createElement(DelayedTransition, {
            key: pathname // we're using seconds but transitiongroup uses ms
            ,
            delay: (0, _secondsMs.getMs)(entryDelay),
            timeout: {
              enter: (0, _secondsMs.getMs)(entryLength),
              exit: (0, _secondsMs.getMs)(exitLength)
            },
            onEnter: function onEnter(node) {
              return !!node && !window.__tl_back_button_pressed && (0, _onEnter.onEnter)({
                node: node,
                action: action,
                inTransition: inTransition,
                entryTrigger: entryTrigger,
                entryProps: entryProps,
                exitProps: exitProps,
                pathname: pathname,
                updateContext: updateContext,
                triggerResolve: triggerResolve,
                preventScrollJump: preventScrollJump,
                hash: hash,
                locationKey: locationKey,
                appearAfter: (0, _secondsMs.getMs)(appearAfter),
                e: e
              });
            },
            onExit: function onExit(node) {
              return !!node && !window.__tl_back_button_pressed && (0, _onExit.onExit)({
                node: node,
                inTransition: inTransition,
                exitTrigger: exitTrigger,
                entryProps: entryProps,
                exitProps: exitProps,
                triggerResolve: triggerResolve,
                e: e
              });
            },
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 53,
              columnNumber: 12
            }
          }, function (transitionStatus) {
            var mount = transitionStatus === 'entering' || transitionStatus === 'entered';
            var states = {
              entry: {
                state: entryState,
                delay: entryDelay,
                length: entryLength
              },
              exit: {
                state: exitState,
                delay: exitDelay,
                length: exitLength
              }
            };
            var current = mount ? states.entry : states.exit;

            var transitionState = _objectSpread({
              transitionStatus: transitionStatus,
              current: current,
              mount: mount
            }, states);

            var exitZindex = exitProps.zIndex || 0;
            var entryZindex = entryProps.zIndex || 1;
            return /*#__PURE__*/_react.default.createElement(_TransitionRenderer.default, {
              mount: mount,
              entryZindex: entryZindex,
              exitZindex: exitZindex,
              transitionStatus: transitionStatus,
              transitionState: transitionState,
              children: children,
              injectPageProps: injectPageProps,
              appearAfter: (0, _secondsMs.getMs)(appearAfter),
              __self: _this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 132,
                columnNumber: 15
              }
            });
          })));
        });
      });
    }
  }]);

  return TransitionHandler;
}(_react.Component);

exports.default = TransitionHandler;